// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LiraryPage-module__bookShelf--e6_Zq {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 32px 0 0;
  padding-right: 80px;
  gap: 8px
}

.LiraryPage-module__bookShelf--e6_Zq .LiraryPage-module__book--Q2B3G {
  filter: drop-shadow(1px 0 0 rgb(0 0 0 / 12%));
}`, "",{"version":3,"sources":["webpack://./src/pages/LibraryPage/LiraryPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB;AACF;;AAEA;EACE,6CAA6C;AAC/C","sourcesContent":[".bookShelf {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-end;\n  padding: 32px 0 0;\n  padding-right: 80px;\n  gap: 8px\n}\n\n.bookShelf .book {\n  filter: drop-shadow(1px 0 0 rgb(0 0 0 / 12%));\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bookShelf": `LiraryPage-module__bookShelf--e6_Zq`,
	"book": `LiraryPage-module__book--Q2B3G`
};
export default ___CSS_LOADER_EXPORT___;
